<template>
	<div
		v-if="visible"
		:class="[theme]"
		class="assist"
		v-click-outside="assistClose"
	>
		<i
			@touchend="assistToggle"
			:class="icon"
			class="assist__toggle"
			aria-label="assist-toggle"
		></i>
		<div :class="[place, isOpenedClassname, direction]" class="assist__wrapper">
			<div
				:class="itemMode"
				class="assist__item">{{ content }}</div>
		</div>
	</div>
</template>

<script>
import {clickOutside} from '@/directives/click-outside';
import {computed, ref} from 'vue';

export default {
	directives: {
		clickOutside
	},
	props: {
		content: {
			type: String,
			default: ''
		},
		theme: {
			type: String,
			default: 'dark' // ['', 'dark']
		},
		itemMode: {
			type: String,
			default: '',
		},
		icon: {
			type: String,
			default: 'fas fa-question-circle'
		},
		place: {
			type: String,
			default: 'middle' // start, middle, end
		},
		direction: {
			type: String,
			default: 'bottom' // ['left', 'bottom', 'top', 'right']
		},
		visible: {
			type: Boolean,
			default: true
		}
	},
	setup() {
		const opened = ref(false);
		const isOpenedClassname = computed(() => opened.value ? 'active' : '');
	
		function assistToggle(){
			opened.value ? assistClose() : assistOpen();
		}
		function assistOpen(){
			opened.value = true;
		}
		function assistClose(){
			opened.value = false;
		}
		
		return {
			isOpenedClassname,
			assistClose,
			assistToggle
		}
	}
}
</script>

<style lang="scss">
@use "@/scss/items/assist/assist";
</style>
